import React from 'react';
import PropTypes from 'prop-types';
import Style from './About.module.scss';
import Description from './Description';

const About = ({ breakpoint, description, image, name }) => (
  <div className={Style.aboutContainer}>
    <div className={Style.header}>About</div>
    <div className={Style.container}>
      <div className={Style.image}>
        <img src={image} alt={name} />
      </div>
      <Description breakpoint={breakpoint} description={description} />
    </div>
    <div className={Style.dividerContainer}>
      <div className={Style.divider} />
    </div>
  </div>
);

export default About;

About.defaultProps = {
  description: '',
  image: '',
  name: '',
};

About.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  description: PropTypes.string,
  image: PropTypes.string,
  name: PropTypes.string,
};
